export const UNDEFINED = 'undefined'
export const ORDER_ID_DEFAULT_VALUE = 0
export const ORDER_ITEM_ID_DEFAULT_VALUE = 0
